/*
 * ImageUpload
 * 图片上传
 * created by zhaoqize
 * zhaoqize
 */
import RooImageUpload from './ImageUpload';
export * from './interface';
export default RooImageUpload;